import { CloseIcon } from "../../icons";
import { useModalDialogContext } from "./hooks";

import type { ModalDialogHeaderProps } from "./modal-dialog.types";

import styles from "./modal-dialog-header.module.css";

export function ModalDialogHeader({
  children,
  className = "",
  ...props
}: Readonly<ModalDialogHeaderProps>) {
  const { onClose } = useModalDialogContext();
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      <div>{children}</div>
      <button type="button" className={styles.CloseIcon} onClick={onClose}>
        <CloseIcon
          title="Fechar"
          size={24}
          viewBox="0 0 24 24"
          color="#2E2D37"
        />
      </button>
    </div>
  );
}
